export default __webpack_public_path__ + "static/media/CIA-Insurance-Proposal-Form-February-2026.f27d1893.pdf";